import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  addAssociation(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML('beforeend', content)
  }

  removeAssociation(event) {
    event.preventDefault()

    const item = event.target.closest('.nested-fields')

    // 既存のレコードの場合は_destroyフィールドを設定
    const destroyInput = item.querySelector('input[name*="_destroy"]')
    if (destroyInput) {
      destroyInput.value = '1'
      item.style.display = 'none'
    } else {
      // 新しいレコードの場合は単純に削除
      item.remove()
    }
  }
}
